import { useCallback, useState } from "react";

export default function useNotifications() {
    const [notifications, setNotifications] = useState([]);

    const pushNotification = useCallback((notification) => {
        setNotifications(prevNotifications => {
            const newNotifications = [...prevNotifications];

            newNotifications.push(notification);

            return newNotifications;
        });

        window.scroll({ top: 0, behavior: "smooth" });
    }, []);

    const removeNotification = useCallback((msg) => {
        setNotifications(prevNotifications => {
            const newNotifications = [...prevNotifications];

            newNotifications.splice(newNotifications.findIndex(n => n.msg === msg), 1);

            return newNotifications;
        });
    }, [setNotifications]);

    const clearNotifications = useCallback(() => {
        setNotifications([]);
    }, [setNotifications]);

    return {
        notifications,
        pushNotification,
        removeNotification,
        clearNotifications,
    };
}